const WINDOWS_1252_BYTES = {
  '€': 0x80,
  '‚': 0x82,
  'ƒ': 0x83,
  '„': 0x84,
  '…': 0x85,
  '†': 0x86,
  '‡': 0x87,
  'ˆ': 0x88,
  '‰': 0x89,
  'Š': 0x8a,
  '‹': 0x8b,
  'Œ': 0x8c,
  'Ž': 0x8e,
  '‘': 0x91,
  '’': 0x92,
  '“': 0x93,
  '”': 0x94,
  '•': 0x95,
  '–': 0x96,
  '—': 0x97,
  '˜': 0x98,
  '™': 0x99,
  'š': 0x9a,
  '›': 0x9b,
  'œ': 0x9c,
  'ž': 0x9e,
  'Ÿ': 0x9f
}

export const repairCsvText = (value) => {
  const text = String(value ?? '')

  if (!/[ÃÂÄÅâ]/.test(text)) return text

  try {
    const bytes = Array.from(text, (char) => {
      const code = char.charCodeAt(0)
      const byte = code <= 255 ? code : WINDOWS_1252_BYTES[char]
      if (byte === undefined) throw new Error('not windows-1252 mojibake')
      return `%${byte.toString(16).padStart(2, '0')}`
    }).join('')

    return decodeURIComponent(bytes)
  } catch {
    return text
  }
}

export const createCsvBlob = (csv) => {
  const text = repairCsvText(csv).replace(/\n/g, '\r\n')
  const bytes = new Uint8Array(2 + text.length * 2)
  bytes[0] = 0xff
  bytes[1] = 0xfe

  for (let i = 0; i < text.length; i += 1) {
    const code = text.charCodeAt(i)
    bytes[2 + i * 2] = code & 0xff
    bytes[3 + i * 2] = code >> 8
  }

  return new Blob([bytes], { type: 'text/csv;charset=utf-16le;' })
}
